'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.peripheral.edit', [])
  .controller('PeripheralEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/peripheral/edit/index.js